<template>
<div class="application"> 
  <RouterView/>
  <ModalsContainer/>
</div>
</template>

<script setup lang="ts">

</script>